import React, { createContext } from 'react';

export const ApplicationContext = createContext();
export const AuthContext = createContext();
export const SettingsContext = createContext();
export const UserRoleAccessContext = createContext();